<template>
  <div class="body-measurement-item border p-2">
    <div class="d-flex justify-content-between align-items-center">
      <span class="mr-2 fs-m">{{ bodyMeasurement.gradeCode | gradeCode }}</span>
      <router-link
        v-if="canEdit"
        :to="`/members/${userId}/profile/body_measurements/${bodyMeasurement.id}`"
        class="text-decoration-none">
        <IconButton
          class="ml-2"
          width="24"
          height="24"
          icon-size="18"
          icon="edit" />
      </router-link>
      <span class="mr-2 fs-s">更新日時 {{ bodyMeasurement.latestUpdateAt | prettyDate }}</span>
      <CollapseButton
        :open="isCollapseOpen"
        @click="toggleCollapse" />
    </div>
    <b-collapse
      :visible="isCollapseOpen">
      <div class="border p-2 mb-2">
        <label class="fs-m font-weight-bold">身長</label>
        <div class="chart-container pr-1 pb-4">
          <LineChart
            v-if="bodyMeasurementDetail"
            :labels="labels"
            :datasets="[heightsDataset]" />
          <div class="chart-labels-table-container">
            <ChartLabelsTable
              v-if="bodyMeasurementDetail"
              :labels="labels"
              :datasets="heightsDataset.data" />
          </div>
        </div>
      </div>
      <div class="border p-2 mb-2">
        <label class="fs-m font-weight-bold">体重</label>
        <div class="chart-container pb-4">
          <LineChart
            v-if="bodyMeasurementDetail"
            :labels="labels"
            :datasets="[weightsDataset]" />
          <div class="chart-labels-table-container">
            <ChartLabelsTable
              v-if="bodyMeasurementDetail"
              :labels="labels"
              :datasets="weightsDataset.data" />
          </div>
        </div>
      </div>
      <div class="border p-2">
        <label class="fs-m font-weight-bold">BMI</label>
        <div class="chart-container">
          <LineChart
            v-if="bodyMeasurementDetail"
            :labels="labels"
            :datasets="[bmiDataset]" />
          <div class="chart-labels-table-container">
            <ChartLabelsTable
              v-if="bodyMeasurementDetail"
              :labels="labels"
              :datasets="bmiDataset.data" />
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import IconButton from '@/components/parts/IconButton.vue'
import LineChart from '@/components/charts/LineChart.vue'
import ChartLabelsTable from '@/components/view/profile/body_measurements/ChartLabelsTable.vue'
export default {
  components: {
    CollapseButton,
    IconButton,
    LineChart,
    ChartLabelsTable
  },
  props: {
    bodyMeasurement: {
      type: Object,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isCollapseOpen: false,
      bodyMeasurementDetail: null,
    }
  },
  computed: {
    months() {
      return [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3]
    },
    labels() {
      return this.months.map(month => `${month}月`)
    },
    heightDataByLabel() {
      return this.bodyMeasurementDetail.bodyMeasurements.reduce((prev, curr) => {
        prev[curr.month] = curr.height
        return prev
      }, {})
    },
    weightDataByLabel() {
      return this.bodyMeasurementDetail.bodyMeasurements.reduce((prev, curr) => {
        prev[curr.month] = curr.weight
        return prev
      }, {})
    },
    bmiDataByLabel() {
      return this.bodyMeasurementDetail.bodyMeasurements.reduce((prev, curr) => {
        prev[curr.month] = curr.bmi
        return prev
      }, {})
    },
    heightsDataset() {
      return {
        data: this.months.map(label => this.heightDataByLabel[label]),
        borderColor: '#0F7ACA',
        label: '身長',
        borderWidth: 1,
      }
    },
    weightsDataset() {
      return {
        data: this.months.map(label => this.weightDataByLabel[label]),
        borderColor: '#0F7ACA',
        label: '体重',
        borderWidth: 1,
      }
    },
    bmiDataset() {
      return {
        data: this.months.map(label => this.bmiDataByLabel[label]),
        borderColor: '#0F7ACA',
        label: 'BMI',
        borderWidth: 1,
      }
    }
  },
  created() {
    this.fetchBodyMeasurementDetail()
  },
  methods: {
    toggleCollapse() {
      this.isCollapseOpen = !this.isCollapseOpen
      if (this.isCollapseOpen) {
        this.fetchBodyMeasurementDetail()
      }
    },
    fetchBodyMeasurementDetail() {
      this.$axios.get(`/profiles/body-measurements/${this.bodyMeasurement.id}/`).then((res) => {
        this.bodyMeasurementDetail = res.data
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.chart-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: scroll;

  .chart-labels-table-container {
    width: 600px;
    padding-left: 8px;
  }
}

</style>